var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex p-4 text-gray-700"},[_c('BaseIcon',{staticClass:"text-blue-500 flex-shrink-0 mt-1 mx-4",attrs:{"name":"info","size":"18"}}),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }